import React from "react"
import styled from "styled-components/macro"

const ContributorByWidget = () => (
	<OuterContainer>
		<Container>
			<a href="https://github.com/Mossworm" target="_blank" rel="noreferrer noopener">
				Contributor <em>Mossworm</em>
			</a>
		</Container>
	</OuterContainer>
)

const OuterContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`

const Container = styled.div`
	background: white;
	box-shadow: var(--button-shadow);
	height: 40px;
	margin: 40px auto 0;
	padding: 0 20px;
	display: grid;
	align-items: center;
	text-transform: uppercase;
	font-size: 14px;
	letter-spacing: 0.03em;
	font-weight: bold;
	color: #bebebe;
	a {
		color: inherit;
		text-decoration: none;
	}
	em {
		color: #3a3a3a;
		font-style: normal;
	}
`

export default ContributorByWidget
